<template>
  <div class="pay">
    <body class="body">
      <div class="body-box">
        <div class="type1">
          <p class="title" style="font-size: 1.17em; font-weight: bold">
            Lưu ý Bạn nhập đầy đủ thông tin sau
          </p>
          <div style="margin-top: 1.25rem">
            <!-- <p class="title" style="padding-top: 0">信息填写</p> -->
            <van-field
              type="text"
              label="Số tiền thanh toán"
              class="phone_number"
              placeholder="Số tiền thanh toán"
              v-model="price"
              :readonly="true"
            />
          </div>
          <div style="margin-top: 1.25rem">
            <!-- <p class="title" style="padding-top: 0">信息填写</p> -->
            <van-field
              type="text"
              :label="$t('textlable1')"
              class="phone_number"
              :placeholder="$t('textlable1')"
              v-model.trim="full_name"
              :error-message="full_name_ts"
            />
          </div>
          <div style="margin-top: 1.25rem">
            <!-- <p class="title" style="padding-top: 0">信息填写</p> -->
            <van-field
              type="number"
              :label="$t('textlable2')"
              class="phone_number"
              :placeholder="$t('textlable2')"
              v-model.trim="phone"
              :error-message="phone_ts"
            />
          </div>
          <div style="margin-top: 1.25rem">
            <!-- <p class="title" style="padding-top: 0">信息填写</p> -->
            <van-field
              type="text"
              :label="$t('textlable3')"
              class="phone_number"
              :placeholder="$t('textlable3')"
              v-model.trim="email"
              :error-message="email_ts"
              @blur="isEmai"
            />
          </div>
        </div>
        <div class="type2" style="margin-top: 1.5rem">
          <p
            class="title"
            style="font-size: 1.17em; font-weight: bold; padding-top: 0"
          >
            Chọn phương thức thanh toán
          </p>
          <div style="margin-top: 1.25rem">
            <van-radio-group v-model="couponSelected">
              <van-radio
                :name="item.name"
                v-for="(item, index) in paymentMethodList"
                :key="index"
                >{{ item.value }}</van-radio
              >
            </van-radio-group>
          </div>
          <!-- <a class="next" @click="getOrderList" ref="next">{{ $t('Next') }}</a> -->
        </div>
        <div class="boxContent" v-if="couponSelected == 'NL'">
          <p>
            Thanh toán trực tuyến AN TOÀN và ĐƯỢC BẢO VỆ, sử dụng thẻ ngân hàng
            trong và ngoài nước hoặc nhiều hình thức tiện lợi khác. Được bảo hộ
            &amp; cấp phép bởi NGÂN HÀNG NHÀ NƯỚC, ví điện tử duy nhất được cộng
            đồng ƯA THÍCH NHẤT 2 năm liên tiếp, Bộ Thông tin Truyền thông trao
            giải thưởng Sao Khuê
            <br />Giao dịch. Đăng ký ví NgânLượng.vn miễn phí
            <a
              href="https://www.nganluong.vn/?portal=nganluong&amp;page=user_register"
              target="_blank"
              >tại đây</a
            >
          </p>
        </div>

        <div class="boxContent" v-if="couponSelected == 'ATM_ONLINE'">
          <p>
            <i>
              <span
                style="
                  color: #ff5a00;
                  font-weight: bold;
                  text-decoration: underline;
                "
                >Lưu ý</span
              >: Bạn cần đăng ký Internet-Banking hoặc dịch vụ thanh toán trực
              tuyến tại ngân hàng trước khi thực hiện.</i
            >
          </p>

          <ul class="cardList clearfix">
            <van-radio-group v-model="bankCode">
              <li
                class="bank-online-methods"
                v-for="(item, index) in bankCodeArr"
                :key="index"
              >
                <van-radio :name="item.name">
                  <i :class="item.calss" :title="item.title"></i>
                </van-radio>
              </li>
            </van-radio-group>
          </ul>
        </div>
        <van-button type="primary" block color="#ededed" @click="submit"
          >thanh toán</van-button
        >
      </div>
    </body>

    <footer class="footer">
      <div class="page-footer">{{ $t('Service') }}(ID:10400)</div>
    </footer>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  name: 'pay',
  data () {
    return {
      phone: '',
      full_name: '',
      email: '',
      price: '2000',
      appId: '',
      email_ts: '',
      phone_ts: '',
      full_name_ts: '',
      paymentMethodList: [
        { name: 'NL', value: 'Thanh toán bằng Ví điện tử NgânLượng' },
        { name: 'ATM_ONLINE', value: 'Thanh toán online bằng thẻ ngân hàng nội địa' }
      ],
      bankCodeArr: [
        { name: 'BIDV', title: 'Ngân hàng TMCP Đầu tư &amp; Phát triển Việt Nam', calss: 'BIDV' },
        { name: 'VCB', title: 'Ngân hàng TMCP Ngoại Thương Việt Nam', calss: 'VCB' },
        { name: 'DAB', title: 'Ngân hàng Đông Á', calss: 'DAB' },
        { name: 'TCB', title: 'Ngân hàng Kỹ Thương', calss: 'TCB' },
        { name: 'MB', title: 'Ngân hàng Quân Đội', calss: 'MB' },
        { name: 'VIB', title: 'Ngân hàng Quốc tế', calss: 'VIB' },
        { name: 'ICB', title: 'Ngân hàng Công Thương Việt Nam', calss: 'ICB' },
        { name: 'EXB', title: 'Ngân hàng Xuất Nhập Khẩu', calss: 'EXB' },
        { name: 'ACB', title: 'Ngân hàng Á Châu', calss: 'ACB' },
        { name: 'HDB', title: 'Ngân hàng Phát triển Nhà TPHCM', calss: 'HDB' },
        { name: 'MSB', title: 'Ngân hàng Hàng Hải', calss: 'MSB' },
        { name: 'NVB', title: 'Ngân hàng Nam Việt', calss: 'NVB' },
        { name: 'VAB', title: 'Ngân hàng Việt Á', calss: 'VAB' },
        { name: 'VPB', title: 'Ngân Hàng Việt Nam Thịnh Vượng', calss: 'VPB' },
        { name: 'SCB', title: 'Ngân hàng Sài Gòn Thương tín', calss: 'SCB' },
        { name: 'PGB', title: 'Ngân hàng Xăng dầu Petrolimex', calss: 'PGB' },
        { name: 'GPB', title: 'Ngân hàng TMCP Dầu khí Toàn Cầu', calss: 'GPB' },
        { name: 'AGB', title: 'Ngân hàng Nông nghiệp &amp; Phát triển nông thôn', calss: 'AGB' },
        { name: 'SGB', title: 'Ngân hàng Sài Gòn Công Thương', calss: 'SGB' },
        { name: 'BAB', title: 'Ngân hàng Bắc Á', calss: 'BAB' },
        { name: 'TPB', title: 'Tền phong bank', calss: 'TPB' },
        { name: 'NAB', title: 'Ngân hàng Nam Á', calss: 'NAB' },
        { name: 'SHB', title: 'Ngân hàng TMCP Sài Gòn - Hà Nội (SHB)', calss: 'SHB' },
        { name: 'OJB', title: 'Ngân hàng TMCP Đại Dương (OceanBank)', calss: 'OJB' }
      ],
      couponSelected: 'NL',
      bankCode: ''

    };
  },
  methods: {
    isEmai () {
      var reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!reg.test(this.email)) {
        this.email_ts = this.$t('textlable8')
      }
      if (reg.test(this.email)) {
        this.email_ts = ''
      }
    },
    allRegs (res) {
      if (res.id == 'full_name') {
        this.full_name_ts = res.full_name_ts
        Toast({
          message: res.full_name_ts,
          forbidClick: true,
          icon: 'fail',
          duration: 2000
        });
      }
      if (res.id == 'phone') {
        this.phone_ts = res.phone_ts
        Toast({
          message: res.phone_ts,
          forbidClick: true,
          icon: 'fail',
          duration: 2000
        });
      }
      if (res.id == 'email') {
        this.email_ts = res.email_ts
        Toast({
          message: res.email_ts,
          forbidClick: true,
          icon: 'fail',
          duration: 2000
        });
      }
    },
    getQueryString (name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(window.location
        .href) || [,
          ""
        ])[1].replace(/\+/g, '%20')) || ''
    },
    submit () {
      Toast.loading({
        message: 'Đang tải...',
        forbidClick: true,
        duration: 0
      });
      if (!this.full_name) {
        Toast.clear();
        this.allRegs({ id: 'full_name', full_name_ts: this.$t('textlable5') })
        return
      }
      if (!this.phone) {
        Toast.clear();
        this.allRegs({ id: 'phone', phone_ts: this.$t('textlable6') })

        return
      }
      if (!this.email) {
        Toast.clear();
        this.allRegs({ id: 'email', email_ts: this.$t('textlable7') })

        return
      }
      if (this.email) {
        var reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (!reg.test(this.email)) {
          Toast.clear();
          this.allRegs({ id: 'email', email_ts: this.$t('textlable8') })
          return
        }
      }
      if (this.couponSelected == 'ATM_ONLINE' && this.bankCode == '') {
        Toast.clear();
        Toast({
          message: 'Hãy chọn thẻ ngân hàng',
          forbidClick: true,
          icon: 'fail',
          duration: 2000
        });
        return
      }
      let bank_code = ''
      if (this.couponSelected == 'ATM_ONLINE') {
        bank_code = this.bankCode
      }
      this.$axios
        .get(
          `../api/api1.php?c=commodity._createNganluongPay&app_id=${this.appId}&type=1&uid=${this.uid}&payment_method=${this.couponSelected}&bank_code=${bank_code}&buyer_fullname=${this.full_name}&buyer_email=${this.email}&buyer_mobile=${this.phone}`
        )
        .then(res => {
          if (res.data.code == 0) {
            Toast.clear();
            window.location.href = res.data.data.pay_url['0']
          } else if (res.data.code == 1) {
            Toast.clear();
            alert(res.data.data.ReturnMsg)
          } else {
            Toast.clear();
            alert(res.data.data.message)
          }
        })
    }
  },
  mounted () {
    let uid = this.getQueryString("uid")
    let price = this.getQueryString("price")
    let appId = this.getQueryString("appId")
    console.log('uid', uid, price, appId)
    if (uid !== '' && uid !== undefined && uid !== null) {
      this.uid = uid;
    }
    if (price !== '' && price !== undefined && price !== null) {
      this.price = price;
    }
    if (appId !== '' && appId !== undefined && appId !== null) {
      this.appId = appId;
    }
  },
}
</script>

<style lang="stylus" scoped>
.pay {
  background-color: #fff;

  .share_head {
    display: flex;
    width: 100%;
    background-color: #313131;

    .left {
      flex: 2;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-left: 0.625rem;
      color: #ffffff;

      img {
        width: 2.375rem;
        height: 2.375rem;
      }

      .left-text {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin-left: 0.625rem;
        font-size: 0.75rem;
        line-height: 0.875rem;

        :first-child {
          margin-top: 0.625rem;
          margin-bottom: 0.375rem;
          font-size: 1rem;
        }

        :last-child {
          color: #cdcdcd;
        }
      }
    }

    .right {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;

      .right-content {
        border-radius: 0.125rem;
        width: 4.1875rem;
        height: 1.5rem;
        font-size: 0.75rem;
        background: #1278F3;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
      }
    }
  }

  .body {
    width: 100%;
    box-sizing: border-box;

    .body-box {
      width: 100%;
      box-sizing: border-box;
      margin: 0 auto;
      padding: 0 0.9375rem;

      .title {
        padding-top: 0.75rem;
        font-size: 0.9375rem;
        color: #222222;
        // font-weight: bold;
        font-family: Microsoft JhengHei;
      }

      .input {
        width: 97%;
        margin-top: 0.6875rem;
        height: 2.375rem;

        input {
          width: 100%;
          height: 2.375rem;
          border: 0.0625rem solid #C9C8CB;
          padding-left: 0.625rem;
          border-radius: 0.375rem;
        }
      }

      .user_info {
        margin-top: 0.8125rem;
        height: 4.5rem;
        display: flex;
        // justify-content: center;
        align-items: center;

        .user-avater {
          border-radius: 50%;
          border: 0.0625rem solid #ccc;
        }

        .user-name {
          margin-left: 1rem;
          // text-align: center;
          height: 4.5rem;
          line-height: 2.0625rem;

          small {
            line-height: 0.3125rem;
            font-size: 0.75rem;
          }
        }
      }

      .pay_types {
        display: flex;
        flex-wrap: wrap;
        // margin-top: 1.5625rem;
        margin-top: 0.625rem;
        width: 100%;
        justify-content: space-between;

        .mycard {
          position: relative;
          // flex: 0 0 100%;
          flex: 0 0 48%;
          // height: 4.58rem;
          height: 3.1875rem;
          border: 0.0625rem solid #cbcbcb;
          // border-radius: 0.25rem;
          border-radius: 0.5rem;
          text-align: center;
          overflow: hidden;
          // margin-left: 2.5%;
          // margin-right: 2.5%;
          margin-top: 0.625rem !important;
          display: flex;
          align-items: center;
          justify-content: center;

          // align-content: flex-start;
          // margin-top: 1.125rem !important;
          img {
            // margin-top: 0.3125rem;
            // width: 10rem;
            width: 8rem;
          }

          &:nth-child(odd) {
            margin-left: 0;
          }
        }

        // &:after {
        // content: '';
        // flex: auto;
        // }
        .active {
          background: #fcc3d1;
          border: 0.0625rem solid #f42b74;
          color: #F55D3E;

          .bage {
            background: #f46c54;
          }
        }
      }

      .next {
        display: inline-block;
        margin-top: 1.25rem;
        width: 100%;
        height: 2.375rem;
        line-height: 2.375rem;
        text-align: center;
        background-color: #6c757d;
        border-color: #6c757d;
        opacity: 0.65;
        font-size: 1rem;
        color: #fff;
        border-radius: 0.25rem;
      }
    }
  }

  .footer {
    width: 85%;
    // margin: 1.25rem auto;
    margin: 0 auto;
    padding: 1.25rem;

    .page-footer {
      color: #a5a5a5;
      font-size: 80%;
      text-align: center;
      line-height: 1rem;

      a {
        display: inline-block;
        color: #007bff;
      }
    }
  }

  .bage {
    width: 5.375rem;
    font-size: 0.9375rem;
    color: #fff;
    background: #a5b1b8;
    position: absolute;
    top: 0;
    right: 0;
    height: 2.25rem;
    text-align: center;
    line-height: 2.25rem;
    border-radius: 0 0 0 0.25rem;
  }

  .phone_number {
    >>>, .van-field {
      padding: 0;
      flex-direction: column;

      .van-field__label {
        width: auto;
      }

      .van-field__control {
        border: 1px solid #cbcbcb;
        padding-left: 0.625rem;
        height: 2.1875rem;
        border-radius: 0.3125rem;
      }
    }
  }

  .select_box {
    margin-top: 0.4rem;

    .select_list {
      width: 100%;
      border: 1px solid #cbcbcb;
      height: 2.1875rem;
      border-radius: 0.3125rem;
    }
  }

  .type2 {
    >>>, .van-radio-group {
      .van-radio {
        margin-top: 1rem;

        .van-radio__label {
          font-size: 0.875rem;
          color: #646566;
        }
      }
    }
  }

  .van-button {
    margin: 1.25rem auto 0;
    width: 12.5rem;

    >>>, .van-button__content {
      .van-button__text {
        color: black;
      }
    }
  }

  .boxContent {
    margin-top: 1.25rem;
    border: 1px solid #cccccc;
    padding: 0.625rem;
    overflow: hidden;

    p {
      line-height: 1.5rem;
    }

    a {
      color: -webkit-link;
      cursor: pointer;
      text-decoration: underline;
    }

    >>>, .van-radio-group {
      display: flex;
      flex-wrap: wrap;

      // justify-content: space-between;
      .van-radio {
        .van-radio__label {
        }
      }
    }
  }

  i.VISA, i.MASTE, i.AMREX, i.JCB, i.VCB, i.TCB, i.MB, i.VIB, i.ICB, i.EXB, i.ACB, i.HDB, i.MSB, i.NVB, i.DAB, i.SHB, i.OJB, i.SEA, i.TPB, i.PGB, i.BIDV, i.AGB, i.SCB, i.VPB, i.VAB, i.GPB, i.SGB, i.NAB, i.BAB { // www.nganluong.vn/webskins/skins/nganluong/checkout/version3/images/bank_logo.png) no-repeat;}
    width: 5rem; // www.nganluong.vn/webskins/skins/nganluong/checkout/version3/images/bank_logo.png) no-repeat;}
    height: 1.875rem; // www.nganluong.vn/webskins/skins/nganluong/checkout/version3/images/bank_logo.png) no-repeat;}
    display: block; // www.nganluong.vn/webskins/skins/nganluong/checkout/version3/images/bank_logo.png) no-repeat;}
    background: url('https://www.nganluong.vn/webskins/skins/nganluong/checkout/version3/images/bank_logo.png') no-repeat; // www.nganluong.vn/webskins/skins/nganluong/checkout/version3/images/bank_logo.png) no-repeat;}
  }

  i.MASTE {
    background-position: 0px -1.9375rem;
  }

  i.AMREX {
    background-position: 0px -3.875rem;
  }

  i.JCB {
    background-position: 0px -5.8125rem;
  }

  i.VCB {
    background-position: 0px -7.75rem;
  }

  i.TCB {
    background-position: 0px -9.6875rem;
  }

  i.MB {
    background-position: 0px -11.625rem;
  }

  i.VIB {
    background-position: 0px -13.5625rem;
  }

  i.ICB {
    background-position: 0px -15.5rem;
  }

  i.EXB {
    background-position: 0px -17.4375rem;
  }

  i.ACB {
    background-position: 0px -19.375rem;
  }

  i.HDB {
    background-position: 0px -21.3125rem;
  }

  i.MSB {
    background-position: 0px -23.25rem;
  }

  i.NVB {
    background-position: 0px -25.1875rem;
  }

  i.DAB {
    background-position: 0px -27.125rem;
  }

  i.SHB {
    background-position: 0px -29.0625rem;
  }

  i.OJB {
    background-position: 0px -31rem;
  }

  i.SEA {
    background-position: 0px -32.9375rem;
  }

  i.TPB {
    background-position: 0px -34.875rem;
  }

  i.PGB {
    background-position: 0px -36.8125rem;
  }

  i.BIDV {
    background-position: 0px -38.75rem;
  }

  i.AGB {
    background-position: 0px -40.6875rem;
  }

  i.SCB {
    background-position: 0px -42.625rem;
  }

  i.VPB {
    background-position: 0px -44.5625rem;
  }

  i.VAB {
    background-position: 0px -46.5rem;
  }

  i.GPB {
    background-position: 0px -48.4375rem;
  }

  i.SGB {
    background-position: 0px -50.375rem;
  }

  i.NAB {
    background-position: 0px -52.3125rem;
  }

  i.BAB {
    background-position: 0px -54.25rem;
  }
}

ul.cardList li {
  cursor: pointer;
  // float: left;
  margin-right: 0;
  padding: 0.3125rem 0.25rem;
  text-align: center;
  // width: 5.625rem;
}
</style>
